import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EndpointFactory } from '../endpoint-factory.service';
import { ConfigurationService, ForceBaseUrl } from '../configuration/configuration.service';
import { IPhoneNumber, MemberPhone, PhoneAssignmentResult } from 'src/app/models/phone';

@Injectable({
    providedIn: 'root'
})
export class PhoneEndpoint extends EndpointFactory {

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('phone', force) + 'phone';
    }

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    getPhones(tenantId: string, memberId: string): Observable<MemberPhone[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/${memberId}`;

        return this.http.get<MemberPhone[]>(endpointUrl)
            .pipe(map((response: MemberPhone[]) => response && response.map(item => new MemberPhone(item))))
            .pipe<MemberPhone[]>(
                catchError(error => {
                    return this.handleError(error);
                }));
    }

    addUpdatePhone(tenantId: string, phone: IPhoneNumber): Observable<MemberPhone> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}`;

        return this.http.put<MemberPhone>(endpointUrl, phone)
            .pipe<MemberPhone>(map(phoneResponse => new MemberPhone(phoneResponse)))
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }


    setAsPrimary(tenantId: string, memberId: string, phoneId: number): Observable<MemberPhone[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/updateprimary/${memberId}/${phoneId}`;

        return this.http.put<MemberPhone[]>(endpointUrl, null)
            .pipe(map(phonesResponse => phonesResponse.map(phoneResponseItem => new MemberPhone(phoneResponseItem))))
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }

    delete(tenantId: string, phoneId: number): Observable<boolean> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/${phoneId}`;

        return this.http.delete<boolean>(endpointUrl)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }

    isPhoneReassigned(tenantId: string, memberId: string, phoneNumber: string, callingSystem: string): Observable<PhoneAssignmentResult> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/${memberId}/${phoneNumber}?callingSystem=${callingSystem}`;

        return this.http.get<PhoneAssignmentResult>(endpointUrl)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                })
            );
    }

    saveFRNDOverride(tenantId: string, memberId: string, phoneNumber: string, callingSystem: string, ignoreFRNDResignment: boolean): Observable<any> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/${memberId}/${phoneNumber}?callingSystem=${callingSystem}&ignoreFRNDResignment=${ignoreFRNDResignment}`;

        return this.http.put(endpointUrl, {})
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                })
            );
    }

}
